import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2425006270/src/eidr-ui-nextjs/src/components/LandingPage.tsx");
